<template>
  <div class="t-content">
    <a-button class="app-btn info-btn mb-5" @click="add">添加新资料</a-button>
    <a-button class="app-btn info-btn mb-5 ml-5" @click="addFromModal">从模版库添加</a-button>
    <a-button v-if="materialList && materialList.length > 0" class="app-btn info-btn mb-5 ml-5" @click="updateSort">
      修改排序
    </a-button>
    <!-- <a-button v-if="(!productTypeList || productTypeList.length === 0) && (!materialList || materialList.length === 0)" class="app-btn info-btn mb-5 ml-5" @click="copyModal">
      复制
    </a-button> -->
    <!-- <a-button class="app-btn info-btn mb-5" style="float:right" @click="addData">添加身份类型</a-button> -->
    <div class="p-m-table">
      <div ref="systemForm" class="hadder" @scroll="sysHandleScroll()">
        <div class="h-t" style="width: 200px;border-right:1px solid #dfdfdf;position:sticky;top: 0;left: 0;">
          资料名称
        </div>
        <div
          v-for="(item, index) in productTypeList"
          :key="index"
          class="h-t"
          style="width: 200px;border-right:1px solid #dfdfdf;padding:0 10px;display:flex"
        >
          <div
            style="
              margin: 0 auto;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            "
          >
            {{ item.dataType }}
          </div>
          <!-- <a-icon
            type="edit"
            style="float:right;line-height:55px;cursor: pointer; color:#fff;margin-right:5px;"
            theme="twoTone"
            @click="editType(index, item)"
          />
          <app-icon
            type="icon-shanchu"
            style="float:right;line-height:55px;cursor: pointer;color:#fff;"
            @click="removeType(index, item.materialTypeId)"
          ></app-icon> -->
        </div>
      </div>
      <div style="display: flex">
        <div ref="externalForm1" class="p-m-title m-tt" style="width:200px;padding-bottom: 10px;" @scroll="synchronousScroll">
          <div
            v-for="(item, index) in materialList"
            :key="index"
            class="content"
            style="border-right:1px solid #dfdfdf;"
            :style="{ background: index % 2 ? '#f8f8f8' : '' }"
          >
            <div class="h-c" style="width:200px">
              <div class="h-c-d" style="width:65%;">
                <div style="display:flex;flex-direction: column;">
                  <div style="text-align:center">{{ item.materialName }}</div>
                  <div style="text-align:center">
                    <span style="margin-right:20px;color:#DF7163;cursor: pointer;" @click="editData(item, index)">
                      编辑
                    </span>
                    <span style="color:#DF7163;cursor: pointer;" @click="removeData(index)">删除</span>
                  </div>
                </div>
              </div>
              <div class="h-c-d" style="width:35%;flex:1;display:flex;flex-direction:column">
                <div class="h-c-item">需要：</div>
                <div class="h-c-item">必填：</div>
              </div>
            </div>
          </div>
        </div>

        <div ref="externalForm" style="flex: 1;" class="p-m-title" @scroll="exterHandleScroll()">
          <div
            v-for="(item, index) in materialList"
            :key="index"
            class="content"
            style="border-left:1px solid #dfdfdf"
            :style="{ background: index % 2 ? '#f8f8f8' : '' }"
          >
            <div class="h-c-1">
              <div
                v-for="(c, ic) in item.children"
                :key="ic"
                class="h-c-1-s"
                :style="{ background: index % 2 ? '#f8f8f8' : '' }"
              >
                <div>
                  <div class="l-input">
                    <a-select v-model="c.isNeed" placeholder="请选择类型">
                      <a-select-option :value="1">需要</a-select-option>
                      <a-select-option :value="0">不需要</a-select-option>
                    </a-select>
                  </div>
                </div>
                <div v-if="c.isNeed">
                  <div class="l-input">
                    <a-select v-model="c.isRequired" placeholder="请选择类型">
                      <a-select-option :value="1">必填</a-select-option>
                      <a-select-option :value="0">非必填</a-select-option>
                    </a-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div ref="externalForm" class="p-m-title" @scroll="exterHandleScroll()">
        <div
          v-for="(item, index) in materialList"
          :key="index"
          class="content"
          style="border-left:1px solid #dfdfdf"
          :style="{ background: index % 2 ? '#f8f8f8' : '' }"
        >
          <div class="h-c" style="width:200px">
            <div class="h-c-d" style="width:65%;">
              <div style="display:flex;flex-direction: column;">
                <div style="text-align:center">{{ item.materialName }}</div>
                <div style="text-align:center">
                  <span style="margin-right:20px;color:#DF7163;cursor: pointer;" @click="editData(item, index)">
                    编辑
                  </span>
                  <span style="color:#DF7163;cursor: pointer;" @click="removeData(index)">删除</span>
                </div>
              </div>
            </div>
            <div class="h-c-d" style="width:35%;flex:1;display:flex;flex-direction:column">
              <div class="h-c-item">需要：</div>
              <div class="h-c-item">必填：</div>
              <div class="h-c-item">分类：</div>
              <div class="h-c-item">审核：</div>
              <div class="h-c-item">回寄：</div>
              <div class="h-c-item">打印：</div>
            </div>
          </div>
          <div class="h-c-1">
            <div
              v-for="(c, ic) in item.children"
              :key="ic"
              class="h-c-1-s"
              :style="{ background: index % 2 ? '#f8f8f8' : '' }"
            >
              <div>
                <div class="l-input">
                  <a-select v-model="c.isNeed" placeholder="请选择类型">
                    <a-select-option :value="1">需要</a-select-option>
                    <a-select-option :value="0">不需要</a-select-option>
                  </a-select>
                </div>
              </div>
              <div v-if="c.isNeed">
                <div class="l-input">
                  <a-select v-model="c.isRequired" placeholder="请选择类型">
                    <a-select-option :value="1">必填</a-select-option>
                    <a-select-option :value="0">非必填</a-select-option>
                  </a-select>
                </div>
              </div>
              <div v-if="c.isNeed">
                <div class="l-input">
                  <a-select v-model="c.materialType" placeholder="请选择">
                    <a-select-option :value="1">电子资料</a-select-option>
                    <a-select-option :value="2">纸质资料</a-select-option>
                  </a-select>
                </div>
              </div>
              <div v-if="c.isNeed">
                <div class="l-input">
                  <a-select v-model="c.isAudit" placeholder="请选择">
                    <a-select-option :value="1">审核</a-select-option>
                    <a-select-option :value="0">不审核</a-select-option>
                  </a-select>
                </div>
              </div>
              <div v-if="c.isNeed">
                <div class="l-input">
                  <a-select v-model="c.isSendBack" placeholder="请选择">
                    <a-select-option :value="1">回寄</a-select-option>
                    <a-select-option :value="0">不回寄</a-select-option>
                  </a-select>
                </div>
              </div>
              <div v-if="c.isNeed">
                <div class="l-input">
                  <a-select v-model="c.isPrint" placeholder="请选择">
                    <a-select-option :value="1">打印</a-select-option>
                    <a-select-option :value="0">不打印</a-select-option>
                  </a-select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <a-modal :title="modal.title" v-model="modal.visible" @ok="handleOk" @cancel="handleCancel" :width="700">
      <div class="detailView">
        <a-form class="form" :form="modal.form" :colon="false" layout="inline">
          <a-form-item label="资料类型" required>
            <a-input
              v-decorator="['dataType', { rules: [{ required: true, message: '请输入资料类型' }] }]"
              placeholder="请输入资料类型"
            ></a-input>
          </a-form-item>
          <a-form-item label="排序值">
            <a-input
              v-decorator="['sort', { rules: [{ required: true, message: '请输入排序值' }] }]"
              placeholder="数字从小到大排序"
            ></a-input>
          </a-form-item>
        </a-form>
      </div>
    </a-modal>
    <a-modal :title="modal1.title" v-model="modal1.visible" @cancel="handleCancel" :width="800">
      <div class="detailView">
        <a-form class="form" :form="modal1.form" :colon="false">
          <a-form-item label="资料名称" required>
            <a-input
              v-decorator="[
                'materialName',
                {
                  rules: [{ required: true, message: '资料名称不能为空' }],
                },
              ]"
              placeholder="请输入资料名称"
            ></a-input>
          </a-form-item>
          <a-form-item label="图片示例">
            <PictureCardUpload
              v-decorator="['samplePictureUrl']"
              preview
              :itemWidth="150"
              :itemHeight="187"
            ></PictureCardUpload>
          </a-form-item>
          <a-form-item label="资料模版">
            <PictureCardUpload
              v-decorator="['templateFileUrl']"
              preview
              :fileType="''"
              :tips="'点击上传'"
              :beforeUpload="beforeUpload"
              :itemWidth="198"
              :itemHeight="124"
            ></PictureCardUpload>
          </a-form-item>
          <a-form-item label="资料描述" :wrapperCol="{ style: 'width: 100%' }" required>
            <RichText
              v-decorator="['description', { rules: [{ required: true, message: '请输入资料描述' }] }]"
            ></RichText>
          </a-form-item>
        </a-form>
      </div>
      <template slot="footer">
        <a-button type="primary" @click="handleCancel" :disabled="formDcb">关闭</a-button>
        <a-button type="primary" @click="handleOk1" :disabled="formDcb">保存</a-button>
      </template>
    </a-modal>
    <a-modal title="修改排序" v-model="sortVisibleType" @ok="sortHandleOk" @cancel="handleCancelSort" :width="800">
      <!-- <draggable group="people" v-model="materialList">
        <div v-for="(item, index) in materialList" :key="index" class="sort-list">
          <div style="display:flex">
            <div style="border-right:1px solid #dffdfdf;width:120px;text-align:center">{{ index + 1 }}</div>
            <div style="flex:1;text-align:cneter">{{ item.materialName }}</div>
          </div>
        </div>
      </draggable> -->
      <draggable v-model="materialList" chosenClass="chosen" forceFallback="true" group="people" animation="800">
        <transition-group>
          <div class="item" v-for="(item, index) in materialList" :key="index + 'material'">
            <div style="border-right:1px solid #dffdfdf;width:120px;text-align:center">{{ index + 1 }}</div>
            <div>
              {{ item.materialName }}
            </div>
          </div>
        </transition-group>
      </draggable>
    </a-modal>
    <MaterialTemplate ref="materialTemplate"></MaterialTemplate>
    <CopyProductInfo ref="copyProductInfo"></CopyProductInfo>
  </div>
</template>

<script>
import RichText from '@/components/RichText'
import PictureCardUpload from '@/components/pictureCardUpload/PictureCardUpload.vue'
import { queryViewMixin, toolMixin } from '@/utils/mixin'
import draggable from 'vuedraggable'
import MaterialTemplate from './MaterialTemplate1.vue'
import CopyProductInfo from './CopyProductInfo.vue'
export default {
  components: {
    PictureCardUpload,
    draggable,
    MaterialTemplate,
    CopyProductInfo,
    RichText,
  },
  props: {
    // materialTypeId: {
    //   type: String,
    //   default: '',
    // },
    productId: {
      type: String,
      default: '',
    },
    visaType: {
      type: Number,
      default: null,
    },
    // dataType: {
    //   type: String,
    //   default: '',
    // },
    // type: {
    //   type: Boolean,
    //   default: false,
    // },
    // productType: {
    //   type: Number,
    //   require: true,
    // },
  },
  mixins: [toolMixin, queryViewMixin],
  data() {
    return {
      formDcb: false,
      sortVisibleType: false,
      oldList: [],
      addModalType: false,
      modal: {
        visible: false,
        form: this.$form.createForm(this),
        title: '添加身份类型',
        data: {},
      },
      modal1: {
        edit: null,
        visible: false,
        form: this.$form.createForm(this),
        title: '添加新资料',
        data: {},
      },
      productTypeList: [],
      materialList: [],
      newObj: {
        materialId: null,
        productId: null,
        materialTypeId: null,
        type: 3,
        materialTemplateId: null,
        materialName: '',
        countryName: '',
        differentRegister: null,
        materialType: 1,
        samplePictureUrl: '',
        templateFileUrl: '',
        description: '',
        isRequired: 0,
        isDisplay: null,
        isPrint: 0,
        isAudit: 0,
        isMeans: null,
        fileType: null,
        isSendBack: 0,
        icon: '',
        isNeed: 1,
      },
      countryList: [],
      capacityType: null,
      capacitySort: null,
      materialId: '',
      activeKey: [1],
      selectIndex: null,
      editModalData: {},
      editIndex: null,
    }
  },
  watch: {
  },
  mounted() {
    this.init()
  },
  computed: {},
  methods: {
    addtype(res) {
      this.productTypeList.push({
        productId: res.productId,
        materialTypeId: res.materialTypeId,
        ...res.params,
      })
      this.materialList.forEach(element => {
        const obj = JSON.parse(JSON.stringify(this.newObj))
        obj.productId = res.productId
        obj.materialTypeId = res.materialTypeId
        obj.type = 3
        obj.materialName = element.materialName
        obj.description = element.description
        obj.samplePictureUrl = element.samplePictureUrl
        obj.templateFileUrl = element.templateFileUrl
        element.children.push(obj)
      })
    },
    updatetype(obj) {
      this.productTypeList.splice(obj.index, 1, {
        dataType: obj.data.dataType,
        sort: obj.data.sort,
      })
    },
    removetypeTo(index) {
      this.materialList.forEach(e => {
        e.children.splice(index, 1)
      })
      this.productTypeList.splice(index, 1)
    },
    async copyModal() {
      const id = await this.$refs.copyProductInfo.start()
      this.copyInit(id)
    },

    updateMaterialType(e, item) {
      if (e === 1) {
        item.isAudit = 1
        item.isSendBack = 0
      }
    },
    handleCancelSort() {
      if (this.oldList && this.oldList.length > 0) {
        this.materialList = JSON.parse(JSON.stringify(this.oldList))
      }
      this.sortVisibleType = false
    },
    sortHandleOk() {
      this.sortVisibleType = false
    },
    updateSort() {
      if (this.materialList && this.materialList.length) {
        this.oldList = JSON.parse(JSON.stringify(this.materialList))
        this.sortVisibleType = true
      } else {
        this.$message.error('暂无数据！')
      }
    },
    // 左右滚动条滚动同步
    sysHandleScroll() {
      this.$refs.externalForm.scrollLeft = this.$refs.systemForm.scrollLeft
    },
    exterHandleScroll() {
      this.$refs.systemForm.scrollLeft = this.$refs.externalForm.scrollLeft
      this.$refs.externalForm1.scrollTop = this.$refs.externalForm.scrollTop
    },
    synchronousScroll() {
      this.$refs.externalForm.scrollTop = this.$refs.externalForm1.scrollTop
    },
    handleCancel() {
      this.modal.visible = false
      this.modal1.visible = false
      this.sortVisibleType = false
      this.modal1.edit = null
      this.formDcb = false
    },
    editData(item, index) {
      this.$nextTick(() => {
        this.safeSetFieldsValue$t(this.modal1.form, { ...item })
      })
      // this.formDcb = false
      this.modal1.edit = index
      // if (item.materialTemplateId) {
      //   this.formDcb = true
      // }
      this.modal1.visible = true
    },
    handleOk() {
      this.modal.form.validateFields(async (errors, values) => {
        if (!errors) {
          const params = values
          let editParams = {}
          if (this.modal.title === '修改身份类型') {
            editParams = this.editModalData
          } else {
            if (this.productTypeList.some(v => v.dataType === params.dataType)) {
              return this.$message.error('名称不可重复添加！')
            }
          }
          try {
            const res = await this.$axios.post('/visa/admin/productMaterial/saveMaterialType', {
              data: {
                productId: this.productId,
                ...params,
                ...editParams,
              },
            })
            if (res.success) {
              if (this.modal.title !== '修改身份类型') {
                this.productTypeList.push({
                  productId: this.productId,
                  materialTypeId: res.data,
                  ...params,
                })
                this.materialList.forEach(element => {
                  const obj = JSON.parse(JSON.stringify(this.newObj))
                  obj.productId = this.productId
                  obj.materialTypeId = res.data
                  obj.type = 3
                  obj.materialName = element.materialName
                  obj.description = element.description
                  obj.samplePictureUrl = element.samplePictureUrl
                  obj.templateFileUrl = element.templateFileUrl
                  element.children.push(obj)
                })
              } else {
                this.productTypeList.splice(this.editIndex, 1, {
                  dataType: params.dataType,
                  sort: params.sort,
                })
              }
            }
            this.$message.success('操作成功!')
            this.modal.visible = false
          } catch (e) {
            console.error(e)
          }
        }
      })
    },
    removeData(index) {
      this.materialList.splice(index, 1)
    },
    async addFromModal() {
      const rows = await this.$refs.materialTemplate.start({ productType: 1 })
      rows.forEach(e => {
        const obj = {
          isNeed: 1,
          materialId: null,
          productId: this.productId ? this.productId : '',
          materialTypeId: null,
          type: 3,
          materialTemplateId: null,
          materialName: e.materialTemplateName,
          countryName: '',
          differentRegister: null,
          materialType: e.materialType,
          samplePictureUrl: e && e.samplePictureUrl ? e.samplePictureUrl : '',
          templateFileUrl: e && e.templateFileUrl ? e.templateFileUrl : '',
          description: e.description,
          isRequired: e.isRequired,
          isDisplay: e.isDisplay,
          isPrint: e.isPrint,
          isAudit: e.isAudit,
          isMeans: e.isMeans,
          fileType: null,
          isSendBack: e.isSendBack,
          icon: '',
          children: [],
        }
        this.productTypeList.forEach(element => {
          const typeObj = JSON.parse(JSON.stringify(this.newObj))
          typeObj.materialTypeId = element.materialTypeId
          typeObj.productId = this.productId
          typeObj.type = 3
          typeObj.materialName = e.materialTemplateName
          typeObj.materialTemplateId = e.materialTemplateId
          typeObj.samplePictureUrl = e && e.samplePictureUrl ? e.samplePictureUrl : ''
          typeObj.templateFileUrl = e && e.templateFileUrl ? e.templateFileUrl : ''
          typeObj.description = e && e.description ? e.description : ''
          typeObj.materialType = e.materialType
          typeObj.samplePictureUrl = e && e.samplePictureUrl ? e.samplePictureUrl : ''
          typeObj.templateFileUrl = e && e.templateFileUrl ? e.templateFileUrl : ''
          typeObj.description = e.description
          typeObj.isRequired = e.isRequired
          typeObj.isDisplay = e.isDisplay
          typeObj.isPrint = e.isPrint
          typeObj.isAudit = e.isAudit
          typeObj.isMeans = e.isMeans
          obj.children.push(typeObj)
        })
        this.materialList.push(obj)
      })
    },
    handleOk1() {
      this.modal1.form.validateFields((errors, values) => {
        if (!errors) {
          const params = values
          if (this.modal1.edit === null) {
            if (this.productTypeList.some(v => v.dataType === params.materialName)) {
              return this.$message.error('名称不可重复添加！')
            }
            const obj = {
              isNeed: 1,
              materialId: null,
              productId: this.productId ? this.productId : '',
              materialTypeId: null,
              type: 3,
              materialTemplateId: null,
              materialName: params.materialName,
              countryName: '',
              differentRegister: null,
              materialType: 1,
              samplePictureUrl: params && params.samplePictureUrl ? params.samplePictureUrl : '',
              templateFileUrl: params && params.templateFileUrl ? params.templateFileUrl : '',
              description: params.description,
              isRequired: 0,
              isDisplay: null,
              isPrint: 0,
              isAudit: 0,
              isMeans: null,
              fileType: null,
              isSendBack: 0,
              icon: '',
              children: [],
            }
            this.productTypeList.forEach(e => {
              const typeObj = JSON.parse(JSON.stringify(this.newObj))
              typeObj.materialTypeId = e.materialTypeId
              typeObj.productId = this.productId
              typeObj.type = 3
              typeObj.materialName = params.materialName
              typeObj.samplePictureUrl = params && params.samplePictureUrl ? params.samplePictureUrl : ''
              typeObj.templateFileUrl = params && params.templateFileUrl ? params.templateFileUrl : ''
              typeObj.description = params && params.description ? params.description : ''
              obj.children.push(typeObj)
            })
            this.materialList.push(obj)
          } else {
            this.materialList[this.modal1.edit].description = params.description
            this.materialList[this.modal1.edit].samplePictureUrl =
              params && params.samplePictureUrl ? params.samplePictureUrl : ''
            this.materialList[this.modal1.edit].templateFileUrl =
              params && params.templateFileUrl ? params.templateFileUrl : ''
            this.materialList[this.modal1.edit].materialName = params.materialName
            this.materialList[this.modal1.edit].children.forEach(e => {
              e.description = params.description
              e.samplePictureUrl = params && params.samplePictureUrl ? params.samplePictureUrl : ''
              e.templateFileUrl = params && params.templateFileUrl ? params.templateFileUrl : ''
              e.materialName = params.materialName
            })
          }
          this.modal1.visible = false
          this.formDcb = false
        }
      })
    },
    removeType(index, materialTypeId) {
      this.$axios
        .post('/visa/admin/productMaterial/deleteByMaterialTypeId', {
          data: {
            materialTypeId: materialTypeId,
          },
        })
        .then(res => {
          if (res.success) {
            this.materialList.forEach(e => {
              e.children.splice(index, 1)
            })
            this.productTypeList.splice(index, 1)
          }
        })
    },
    editType(index, record) {
      this.editIndex = index
      this.modal.visible = true
      this.modal.title = '修改身份类型'
      this.$nextTick(() => {
        this.modal.form.setFieldsValue({
          dataType: record.dataType,
          sort: record.sort,
        })
        this.editModalData = {
          materialTypeId: record.materialTypeId,
          productId: record.productId,
        }
      })
    },
    async removeRow(row) {
      await new Promise((resolve, reject) => {
        this.$confirm({
          title: '提示',
          content: '确定删除?',
          onOk: () => {
            resolve()
          },
          onCancel: () => {
            reject(new Error('E_CANCEL'))
          },
        })
      })
      await this.$axios.post('/visa/admin/productMaterial/deleteByMaterialTypeId', {
        data: {
          materialTypeId: row.materialTypeId,
        },
      })
      this.$message.success('操作成功!')
    },
    
    async copyInit(productId) {
      if (productId) {
        const resData = await this.$axios.post('/visa/admin/productMaterial/queryByProductId', {
          data: {
            productId,
          },
        })
        if (resData.data) {
          let count = 0
          const list = {}
          resData.data.forEach(async (e) => {
            const res = await this.$axios.post('/visa/admin/productMaterial/saveMaterialType', {
              data: {
                ...e,
                productId: this.productId,
                materialTypeId: null
              },
            })
            if(res.success) {
              count++
              list[e.materialTypeId] = res.data
              if(count === resData.data.length) {
                this.assemblyDaata(productId, list)
              }
            }
          })
        }
      }
    },

    async assemblyDaata(productId, obj) {
      const resData = await this.$axios.post('/visa/admin/productMaterial/queryByProductId', {
          data: {
            productId: this.productId,
          },
        })
      // 根据产品id 查询资料列表
      const res = await this.$axios.post('/visa/admin/productMaterial/queryMaterialListByProductId', {
        data: {
          productId,
        },
      })
      const resList = res.data.map(v => {
        return {
          ...v,
          productId: this.productId,
          materialTypeId: obj[v.materialTypeId]
        }
      })
      if (res.success) {
        const obj = {}
        const list = resList.filter(v => parseInt(v.type) === 3)
        const resToData = JSON.parse(JSON.stringify(list))
        const peon = list.reduce((cur, next) => {
          if (!obj[next.materialName]) {
            obj[next.materialName] = true && cur.push(next)
          }
          return cur
        }, [])
        if (resData.data && resData.data.length > 0) {
          peon.forEach(element => {
            element['children'] = []
            resData.data.forEach(async (e) => {
              element.materialTypeId = e.materialTypeId
              const obj = JSON.parse(JSON.stringify(this.newObj))
              obj.productId = this.productId
              obj.materialTypeId = e.materialTypeId
              obj.type = 3
              obj.materialName = element.materialName
              obj.samplePictureUrl = element && element.samplePictureUrl ? element.samplePictureUrl : ''
              obj.templateFileUrl = element && element.templateFileUrl ? element.templateFileUrl : ''
              obj.description = element && element.description ? element.description : ''
              element.children.push(obj)
            })
          })
        }
        this.materialList = JSON.parse(JSON.stringify(peon))
        this.productTypeList = resData.data
        this.productTypeList.forEach((ptype, index) => {
          this.materialList.forEach(e => {
            let obj = null
            if (e.children) {
              e.children.forEach(l => {
                obj = resToData.find(
                  v => v.materialTypeId === ptype.materialTypeId && e.materialName === v.materialName
                )
              })
            }
            
            if (obj) {
              e.children[index] = Object.assign(e.children[index], obj)
              e.children[index]['isNeed'] = 1
            }
          })
        })
        this.materialList.forEach(e => {
          if (e.children) {
            e.children.forEach(e => {
              if (!e.materialId) {
                e.isNeed = 0
              }
            })
          }
        })
        // await this.updateProductId(this.materialList)
        this.materialList = JSON.parse(JSON.stringify(this.materialList))
      }
    },


    
    updateProductId(list) {
      list.forEach(element => {
        if (element.children) {
          element.productId = this.productId
          this.updateProductId(element.children)
        }
      })
    },
    async init() {
      if (this.productId) {
        const resData = await this.$axios.post('/visa/admin/productMaterial/queryByProductId', {
          data: {
            productId: this.productId,
          },
        })
        // 根据产品id 查询资料列表
        const res = await this.$axios.post('/visa/admin/productMaterial/queryMaterialListByProductId', {
          data: {
            productId: this.productId,
          },
        })

        if (res.success) {
          const obj = {}
          const list = JSON.parse(JSON.stringify(res.data.filter(v => parseInt(v.type) === 3)))
          const resToData = res.data.filter(v => parseInt(v.type) === 3)
          const peon = list.reduce((cur, next) => {
            if (!obj[next.materialName]) {
              obj[next.materialName] = true && cur.push(next)
            }
            return cur
          }, [])
          if (resData.data && resData.data.length > 0) {
            peon.forEach(element => {
              element['children'] = []
              resData.data.forEach(e => {
                const obj = JSON.parse(JSON.stringify(this.newObj))
                obj.productId = this.productId
                obj.materialTypeId = e.materialTypeId
                obj.type = 3
                obj.materialName = element.materialName
                obj.samplePictureUrl = element && element.samplePictureUrl ? element.samplePictureUrl : ''
                obj.templateFileUrl = element && element.templateFileUrl ? element.templateFileUrl : ''
                obj.description = element && element.description ? element.description : ''
                element.children.push(obj)
              })
            })
          }
          this.materialList = peon
          this.productTypeList = resData.data
          this.productTypeList.forEach((ptype, index) => {
            this.materialList.forEach(e => {
              let obj = null
              if (e.children) {
                e.children.forEach(l => {
                  obj = resToData.find(
                    v => v.materialTypeId === ptype.materialTypeId && e.materialName === v.materialName
                  )
                })
              }
              if (obj) {
                e.children[index] = Object.assign(e.children[index], obj)
                e.children[index]['isNeed'] = 1
              }
            })
          })
          this.materialList.forEach(e => {
            if (e.children) {
              e.children.forEach(e => {
                if (!e.materialId) {
                  e.isNeed = 0
                }
              })
            }
          })
        }
      }
    },
    async addData() {
      this.resetModal$t()
      this.modal.visible = true
      this.modal.title = '添加身份类型'
    },
    getList() {
      const list = []
      let index = 1
      this.materialList.forEach(e => {
        if (e.children) {
          e.children.forEach(l => {
            if (l.isNeed) {
              l.materialSort = index
              l.productId = this.productId
              list.push(l)
            }
            index++
          })
        }
      })
      return list
    },
    async add() {
      this.modal1.form.resetFields()
      this.modal1.edit = null
      this.modal1.visible = true
    },
    remove(row, index) {
      if (row.materialId) {
        this.$confirm({
          title: '提示',
          content: '确定删除?',
          onOk: () => {
            this.$axios
              .post('/visa/admin/productMaterial/deleteByMaterialId', {
                data: {
                  materialId: row.materialId,
                },
              })
              .then(res => {
                if (res.success) {
                  this.loadList()
                  this.$message.success('操作成功!')
                } else {
                  // 删除失败提示
                }
              })
          },
        })
      } else {
        this.materialList.splice(index, 1)
      }
      this.loadList(this.materialTypeId)
    },
    saveAsModel() {
      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          this.resetModal$t()
          this.modal.visible = true
        }
      })
    },
    beforeUpload(file) {
      if (!file.name.toLowerCase().match(/\.(doc|docx|pdf|xls|xlsx|jpg|png|bmp)$/)) {
        this.$message.error('请上传doc、docx、xls、xlsx、pdf文件或jpg、png、bmp图片')
        return false
      }
    },
  },
}
</script>
<style lang="less">
.l-input {
  .ant-select-selection--single {
    width: 100%;
  }
  .ant-select-selection__placeholder {
    display: auto !important;
  }
}
</style>
<style lang="less" scoped>
.m-tt::-webkit-scrollbar {
  display: none;
}
.sort-list {
  border: 1px solid #dfdfdf;
  padding: 10px 0;
  margin-bottom: 10px;
  border-radius: 10px;
}
.t-content {
  // margin-top: 30px;
  
  .p-m-table {
    border: 1px solid #dfdfdf;
    margin-bottom: 30px;
    width: 100%;
    .hadder {
      overflow-y: auto;
      display: flex;
      background: #fd7163;
      position: relative;
      padding-right: 10px;
      .h-t {
        flex-shrink: 0;
        background: #fd7163;
        color: #fff;
        line-height: 50px;
        text-align: center;
      }
    }
    .hadder::-webkit-scrollbar {
      display: none;
    }
    .p-m-title {
      top: 50px;
      bottom: 0;
      width: 100%;
      min-height: 100px;
      max-height: 500px;
      overflow: auto;
      // overflow-y: hidden;
      .hadder {
        display: flex;
        background: #fd7163;
        .h-t {
          flex-shrink: 0;
          height: 50px;
          background: #fd7163;
          color: #fff;
          line-height: 50px;
          text-align: center;
        }
      }
      .content {
        flex-shrink: 0;
        display: flex;
        flex-direction: row;
        .h-c {
          flex-shrink: 0;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .h-c-d {
            flex-shrink: 0;
            border: 1px solid #dfdfdf;
            height: 84px;
            display: flex;
            justify-content: center;
            align-items: center;
            .h-c-item {
              height: 20%;
              line-height: 40px;
              text-align: center;
              border-bottom: 1px solid #dfdfdf;
              width: 100%;
              &:last-child {
                border-bottom: none;
              }
            }
          }
        }
        .h-c-1 {
          flex: 1;
          display: flex;
          .h-c-1-s {
            flex-shrink: 0;
            width: 200px;
            display: flex;
            flex-direction: column;
            div {
              flex-shrink: 0;
              height: 42px;
              display: flex;
              .l-title {
                flex-shrink: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                border: 1px solid #dfdfdf;
                width: 120px;
              }
              .l-input {
                flex-shrink: 0;
                flex: 1;
                border: 1px solid #dfdfdf;
                text-align: center;
                padding: 4px 20px 0 20px;
              }
            }
          }
        }
      }
    }
    // .p-m-title::-webkit-scrollbar {
    //   display: none;
    // }
  }
}
/*被拖拽对象的样式*/
.item {
  display: -webkit-box;
  padding: 6px;
  background-color: #fdfdfd;
  border: solid 1px #eee;
  margin-bottom: 10px;
  cursor: move;
}
/*选中样式*/
.chosen {
  border: solid 1px #3089dc !important;
}
</style>
